module.exports = __webpack_public_path__ + "static/segmentation-user-research-91efe6d6471731fb06392353d6c425af.png";